
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Fiftyzerobusonrentinpune() {



  const cardData =
  {
    keyword: ' 50 Seater Bus on Rent in Pune',
    heading: 'Vaishnavi Travels: 50 Seater Bus on Rent in Pune',
    headingDescription: 'Vaishnavi Travels offers affordable and dependable 50 Seater Bus on Rent in Pune, ideal for large gatherings such as weddings, school excursions, corporate outings, and long outstation tours. Our buses are spacious and well-maintained with comfortable seating, strong air-conditioning, and ample luggage capacity to ensure a smooth and enjoyable journey for every passenger. With trained drivers, timely pickups, and flexible booking options, we make group travel stress-free and convenient. Whether it’s a religious yatra, family function, business trip, or holiday tour, Vaishnavi Travels guarantees safe, reliable, and comfortable 50 seater bus rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Once the seat of power of the Maratha Empire, its mighty gates, sprawling gardens, and ruined bastions narrate tales of valor and glory. Though partially destroyed by a fire in 1828, the fort still stands as a majestic landmark. The evening light-and-sound show recreates the romance of Bajirao and Mastani and the grandeur of the Peshwas. Thousands of visitors explore its corridors, courtyards, and gardens every day. Shaniwar Wada remains Pune’s proud cultural and historic centerpiece."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument closely tied to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its majestic Italian arches, sprawling lawns, and colonial architecture make it a popular attraction. Tourists enjoy the calm and serene ambiance of its gardens while soaking in history. Aga Khan Palace stands as Pune’s inspirational monument of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 25 km from Pune, Sinhagad Fort is famous for the 1670 battle in which Tanaji Malusare fought heroically for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers panoramic views of the Sahyadris and trekking opportunities for adventure lovers. The fort is dotted with ancient bastions, temples, and memorials echoing Maratha bravery. In monsoon, mist and waterfalls add a magical touch to the trek. Local villagers serve traditional pithla-bhakri, making the trip even more authentic. Sinhagad is Pune’s perfect mix of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established more than 125 years ago, the temple is famous for its magnificent idol adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the epicenter of vibrant celebrations attracting lakhs of devotees. Beyond rituals, the temple is renowned for its charitable, cultural, and social initiatives. Tourists and devotees alike experience the spiritual energy and grandeur here. Dagdusheth Ganpati is Pune’s spiritual and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, the Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. Featuring massive stone pillars, a sanctum, and a Nandi mandapa, it is a fine example of early Indian rock-cut architecture. Despite being located in the city center, the temple offers a peaceful and meditative environment. Evening prayers and chants fill the air with devotion and serenity. Tourists admire the craftsmanship and historical charm of this hidden heritage site. Pataleshwar Cave Temple is Pune’s spiritual retreat in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure trove showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits range from musical instruments, sculptures, and ornaments to everyday household objects of past centuries. The recreated Mastani Mahal is a highlight that fascinates history lovers. Students and tourists find the museum both educational and inspiring. It preserves India’s cultural traditions and artistry across eras. Raja Dinkar Kelkar Museum is Pune’s proud celebration of heritage, history, and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city from its hilltop temple complex. The Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and museums nearby add cultural depth to the visit. Visitors climb 103 stone steps to reach the top, combining devotion with a healthy trek. Sunrise and sunset views from here are truly mesmerizing. Parvati Hill is Pune’s sacred and scenic escape above the city."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort, located in Koregaon Park, is Pune’s global destination for spirituality, wellness, and mindfulness. Spread across beautifully landscaped gardens, it attracts seekers and tourists from across the world. The ashram offers meditation techniques, yoga practices, and personal growth workshops. Japanese Zen gardens and tranquil meditation halls create a serene atmosphere. Beyond spirituality, it promotes rejuvenation and holistic living. Osho Ashram is Pune’s international hub of peace, healing, and inner growth."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Inspired by the famous Korakuen Garden in Japan, Pu La Deshpande Garden is Pune’s largest landscaped park. It is designed with flowing streams, stone bridges, manicured lawns, and seasonal flowers. Families enjoy picnics, peaceful walks, and photography in this lush setting. The garden is also a symbol of Indo-Japanese cultural friendship. Nature lovers find it refreshing throughout the year, especially in spring. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built across the Mutha River, is a popular weekend spot just outside Pune. It not only supplies water to the city but also offers stunning views of hills, backwaters, and sunsets. In monsoon, the overflowing dam creates breathtaking sights. Locals and tourists enjoy roadside snacks like roasted corn and tea along the banks. It is also the starting point for trips to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway for families and travelers alike."
  }
],

"services": [
{
"name": "50 Seater Bus Hire Pune",
"description": "Efficient and spacious 50 seater bus hire service in Pune, designed to accommodate mega groups with ease. Perfect for large family gatherings, corporate outings, school functions, and weddings, these buses offer comfortable seating, ample luggage space, and modern amenities. Our fleet includes both AC and non-AC options, ensuring a tailored travel experience to suit every budget and preference."
},
{
"name": "Mega Group Bus Rental Pune",
"description": "Specialized rental services catering to mega groups needing 50 seater buses in Pune. Ideal for big events like conferences, large weddings, and group tours, these buses provide superior comfort and safety features. With flexible booking durations and professional drivers, your group’s transportation needs are fully managed for a hassle-free journey."
},
{
"name": "School Function 50 Seater Bus Pune",
"description": "Safe and reliable 50 seater buses tailored for school functions and events in Pune. Equipped with child safety features and experienced drivers, these buses ensure smooth transportation for large student groups to and from academic and extracurricular activities. Ideal for school trips, competitions, and annual functions."
},
{
"name": "50 Seater Wedding Bus Rental",
"description": "Elegant 50 seater wedding bus rental services in Pune, offering both AC and non-AC buses to comfortably transport large wedding guest lists. These buses are perfect for shuttling guests between venues, hotels, and reception locations with timely pickups, courteous drivers, and optional decorative services to enhance your special day."
},
{
"name": "AC Bus 50 Seater Pune",
"description": "Premium air-conditioned 50 seater buses available for hire in Pune, ensuring a cool and comfortable travel experience even during hot weather. Equipped with modern amenities such as reclining seats, entertainment systems, and spacious interiors, these buses are ideal for long-distance tours, corporate events, and wedding transportation."
},
{
"name": "Non AC 50 Seater Bus Booking",
"description": "Cost-effective non-AC 50 seater bus rental solutions in Pune, perfect for budget-conscious groups needing reliable transportation for local trips, school functions, and casual group travel. Despite the economical rates, these buses maintain high standards of safety and cleanliness, providing a dependable travel option for large groups."
},
{
"name": "Outstation 50 Seater Bus Pune",
"description": "Trusted 50 seater outstation bus rental services from Pune, catering to long-distance group travel requirements. These buses come with experienced drivers familiar with interstate routes, ensuring safety, comfort, and timely arrivals. Packages include driver charges, tolls, and can be customized for multi-day trips and sightseeing tours."
},
{
"name": "50 Seater Corporate Bus Hire",
"description": "Professional 50 seater corporate bus hire services in Pune, designed to transport large teams efficiently for meetings, conferences, seminars, and company outings. Our buses offer AC and non-AC options, Wi-Fi availability on request, and courteous drivers trained to handle corporate schedules with punctuality and professionalism."
},
{
"name": "Tourist Bus 50 Seater Pune",
"description": "Comfortable 50 seater tourist bus rentals in Pune ideal for group sightseeing, religious tours, and hill station visits. These buses feature spacious seating, large windows for panoramic views, and optional AC for maximum comfort. Customizable routes and professional driver services make your tour smooth and enjoyable."
},
{
"name": "Family Function Bus 50 Seater",
"description": "Spacious 50 seater buses perfect for large family functions and celebrations in Pune. Whether for weddings, anniversaries, or reunions, these buses provide ample room, comfort, and safety features. Drivers prioritize punctuality and guest comfort to ensure stress-free transportation throughout your event."
},
{
"name": "Office Staff 50 Seater Bus Hire",
"description": "Reliable 50 seater bus rental services in Pune for office staff transportation, suitable for daily commutes, special corporate events, and team outings. Buses come with both AC and non-AC options, well-maintained interiors, and professional drivers ensuring timely and comfortable rides for employees."
},
{
"name": "Long Route 50 Seater Bus Pune",
"description": "Dependable long-route 50 seater bus rental services from Pune, suitable for interstate travel, corporate tours, and large group excursions. These buses offer comfortable seating, ample storage space, and optional AC, driven by experienced drivers well-versed with highway routes to ensure a smooth, safe, and punctual journey."
},
{
"name": "Rent 50 Seater Bus Online",
"description": "Convenient online booking service for 50 seater bus rentals in Pune, providing instant confirmation, transparent pricing, and customizable add-ons such as decorations, refreshments, and itinerary planning. Book your bus anytime with easy payment options and dedicated customer support for a hassle-free rental experience."
}
],
"tableData": [
["50 Seater Bus Hire Pune", "Mega Group Bus Rental Pune"],
["School Function 50 Seater Bus Pune", "50 Seater Wedding Bus Rental"],
["AC Bus 50 Seater Pune", "Non AC 50 Seater Bus Booking"],
["Outstation 50 Seater Bus Pune", "50 Seater Corporate Bus Hire"],
["Tourist Bus 50 Seater Pune", "Family Function Bus 50 Seater"],
["Office Staff 50 Seater Bus Hire", "Long Route 50 Seater Bus Pune"],
["Rent 50 Seater Bus Online"]
],




"whychoose": [
  {
    "WhyChooseheading": "Affordable 50 Seater Bus on Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers dependable and budget-friendly 50 seater bus rentals in Pune, perfect for very large groups and special events."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating for Large Groups",
    "WhyChoosedescription": "Our 50 seater buses provide ample legroom and comfortable seats, ensuring a smooth and enjoyable journey for all passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly cleaned to maintain the highest standards of safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages to Suit Your Needs",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options customized to your travel plans and group size."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers ensure safe, timely, and courteous service, familiar with Pune routes and surroundings."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Enjoy all-inclusive pricing covering fuel, tolls, taxes, and driver allowances for a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Events, Weddings, and Large Group Travel",
    "WhyChoosedescription": "Perfect for corporate functions, weddings, sightseeing tours, and any large group outings in Pune and beyond."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Vaishnavi Travels provides round-the-clock customer support to assist with bookings, changes, and travel inquiries."
  }
]



































  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 50 seater buses for rent in Pune?',
      answer: 'Yes, Vaishnavi Travels provides reliable 50‑seater buses for rent in Pune. These buses are perfect for large group travel — weddings, corporate events, school or pilgrimage tours, and outstation journeys. We ensure safety, cleanliness, and comfort throughout your trip.',
    },
    {
      question: 'Are both AC and non‑AC 50 seater options available?',
      answer: 'Absolutely. We have both AC and non‑AC 50‑seater buses. AC variants offer enhanced comfort especially in summer or for long trips; non‑AC options are more economical but still maintain high standards of safety and maintenance.',
    },
    {
      question: 'What are the approximate rates for a 50 seater bus in Pune?',
      answer: 'For non‑AC models, rate is roughly **₹34 per km** under typical outstation / daily‑km packages. AC models tend to be around **₹50–₹60/km**, depending on route, amenities, and extra charges. Minimum km/day is often around 250‑300 km. Local day packages may vary based on duration. ',
    },
    {
      question: 'What amenities can we expect in a 50 seater bus from Vaishnavi Travels?',
      answer: 'Amenities usually include push‑back or reclining seats, good legroom, overhead storage, music/audio‑video setup, charging points, large windows, and for AC models, full climate control. Safety features like well‑trained drivers, GPS, and emergency kits are standard.',
    },
    {
      question: 'Are extra charges included or separate?',
      answer: 'Extra costs are not usually part of the base fare. You will likely have to pay tolls, parking, driver allowances (especially for overnight stays), any permits for special routes, and charges for extra kilometres or hours beyond the package. We provide transparent estimates to avoid surprises.',
    },
    {
      question: 'How far in advance should I book a 50 seater bus?',
      answer: 'For local trips, booking at least **2‑3 days** in advance is advisable. For outstation, weddings, or peak season (holidays, festivals), booking **1‑2 weeks** ahead is safer to ensure availability and better pricing.',
    },
    {
      question: 'Can pickup and drop be from different locations or multiple points?',
      answer: 'Yes, we can arrange multiple pickup and drop‑off points within Pune or en route for outstation trips. This is planned in advance, and any extra travel time or distance is included in the quote to make sure all logistics are clear.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Atharva Patil",
    position: "Corporate Travel Lead",
    feedback:
      "We booked a 50‑seater AC bus from Vaishnavi Travels for our annual company retreat. Everyone was comfortable, the interiors were clean, and the air conditioning worked well even on highways. The driver was punctual, polite and handled long hours professionally. Transparent billing was a big plus — no hidden costs showed up, everything was explained beforehand.",
    rating: 5,
  },
  {
    name: "Mrs. Meera Kulkarni",
    position: "Coordinator, School Tour Committee",
    feedback:
      "Our school’s educational trip used a 50‑seater non‑AC bus from Vaishnavi Travels. Although it was non‑AC, the vehicle was well ventilated, the seats were comfortable, and there was enough space for luggage. The driver managed stops efficiently, and safety measures were well observed. The booking process was simple, and the service made the trip stress‑free for our students and teachers alike.",
    rating: 5,
    style: "style-2",
  },
];


















































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "50 Seater Bus on Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/50-seater-bus-pune.jpg",
  "description": "Rent a 50 seater bus in Pune with Vaishnavi Travels for mega group travel including school functions, weddings, corporate events, and family outings. Available in AC and Non AC variants with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.84",
    "ratingCount": "2150"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6200",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/50-seater-bus-on-rent-in-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>50 Seater Bus on Rent in Pune | Mega Group Bus Rental | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Rent a 50 seater bus in Pune with Vaishnavi Travels for mega group travel including school functions, weddings, corporate events, and family outings. Available in AC and Non AC variants with professional drivers."
  />
  <meta
    name="keywords"
    content="50 Seater Bus Hire Pune, Mega Group Bus Rental Pune, School Function 50 Seater Bus Pune, 50 Seater Wedding Bus Rental, AC Bus 50 Seater Pune, Non AC 50 Seater Bus Booking, Outstation 50 Seater Bus Pune, 50 Seater Corporate Bus Hire, Tourist Bus 50 Seater Pune, Family Function Bus 50 Seater, Office Staff 50 Seater Bus Hire, Long Route 50 Seater Bus Pune, Rent 50 Seater Bus Online"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fiftyzerobusonrentinpune;